import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Space,
  Typography,
} from 'antd';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../redux/message.reducer';
import CommentAttachmentInput from '../../../components/CommentAttachments/CommentAttachmentInput';
import '../EncyclopediaForm.css';

export default function CreateEncyclopedia() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (!values.name?.trim()) {
      dispatch(setMessage({ message: 'Name is required', type: 'warning' }));
      return;
    }
    const list = Array.isArray(values.attachments) ? values.attachments : [];
    if (list.length > 5) {
      dispatch(setMessage({ message: 'Maximum 5 attachments allowed', type: 'warning' }));
      return;
    }
    setSubmitLoading(true);
    try {
      await axios.post('/encyclopedia', {
        name: values.name.trim(),
        description: values.description != null ? String(values.description).trim() : '',
        attachments: list,
      });
      dispatch(setMessage({ message: 'Entry created', type: 'success' }));
      navigate('/encyclopedia');
    } catch (err) {
      const msg = err.response?.data?.error || 'Create failed';
      dispatch(setMessage({ message: msg, type: 'error' }));
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="encyclopedia-form-page">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div className="encyclopedia-form-header">
          <div className="encyclopedia-form-header-left">
            <Typography.Title level={3} style={{ margin: 0 }}>
              New encyclopedia entry
            </Typography.Title>
          </div>
          <Space>
            <Button
              type="primary"
              size="large"
              loading={submitLoading}
              onClick={() => form.submit()}
              className="app-btn-primary"
            >
              Save
            </Button>
            <Button size="large" onClick={() => navigate('/encyclopedia')} className="app-btn-cancel">
              Cancel
            </Button>
          </Space>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="encyclopedia-form"
          initialValues={{
            name: '',
            description: '',
            attachments: [],
          }}
        >
          <Card className="encyclopedia-form-card">
            <div className="encyclopedia-form-body">
              <Row gutter={16}>
                <Col xs={24}>
                  <Form.Item
                    name="name"
                    label="Name"
                    required
                    rules={[{ required: true, message: 'Name is required' }]}
                  >
                    <Input placeholder="Name" maxLength={200} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea placeholder="Description" rows={6} maxLength={5000} showCount />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="attachments"
                    label="Attachments (up to 5 files)"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (Array.isArray(value) && value.length > 5) {
                            return Promise.reject(new Error('Maximum 5 attachments'));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <CommentAttachmentInput />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Card>
        </Form>
      </Space>
    </div>
  );
}
